import React from 'react'
import Branches from '../components/Branches';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Legal from '../components/Legal';
import Membership from '../components/Membership';
import Navbar from '../components/Navbar';
import Products from '../components/Products';

const Home = () => {
    return (


        <main>
            <Hero />
            <Products />
            <Membership />
            <Branches />
            <Legal />
            <Contact />
        </main>

    )
}

export default Home
